import { render, staticRenderFns } from "./internalResultAttach.vue?vue&type=template&id=6f163ea8"
import script from "./internalResultAttach.vue?vue&type=script&lang=js"
export * from "./internalResultAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f163ea8')) {
      api.createRecord('6f163ea8', component.options)
    } else {
      api.reload('6f163ea8', component.options)
    }
    module.hot.accept("./internalResultAttach.vue?vue&type=template&id=6f163ea8", function () {
      api.rerender('6f163ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/internalResultAttach.vue"
export default component.exports